import React, { VFC } from 'react';

import { UsersitePlansGetManyPlansTypePayload } from '~/models/schema';
import { ArticleProps } from '~/src/core/Articles/props';
import { Props as HeaderProps } from '../../components/Header';
import TopComponent from './template';

export type Plan = {
  key: string;
  plans: Array<UsersitePlansGetManyPlansTypePayload>;
  queryParams?: string;
};

export type ThemePageCard = {
  id: number;
  slug: string;
  headline: string;
  headerImageUrl: string | null;
};

export type RegionCityPageCard = {
  id: number;
  prefectureName: string;
  cityName: string;
  cityNameHirakana: string;
  description: string;
  coverImageUrl: string | null;
};

export type Props = HeaderProps & {
  plans: Plan[];
  businesses: Array<Object>;
  news: Array<ArticleProps>;
  themePages: ThemePageCard[];
  activeRegionCityPages: RegionCityPageCard[];
  regions?: Array<Object>;
  businessCategories?: Array<Object>;
};
const Top: VFC<Props> = (props: Props) => {
  return <TopComponent {...props} />;
};

export default Top;
